import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import tableSportRoomContentCatalog from './tableSportRoomContentCatalog';
import viewAppCategories from './viewRelatedAppCategories';
import viewRelatedAppPackages from './viewRelatedAppPackages';
import viewRelatedSportRoomPackages from './viewRelatedSportRoomPackages';
import viewRelatedSportRoomTags from './viewRelatedSportRoomTags';
export default {

  attributeName: 'appContent',
  isDragable: false,
  canOpen: true,
  canChangePosition: true,
  sortingPositionIndex: 'sortingIndex',
  isMultiSelectable: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  // bulkDelete: true,
  bulkSelectable: true,
  bulkButtons: [
    {
      label: "Import Sportroom contents",
      color: ButtonTheme.INFO,
      action: "bulkImport",
      actionUrl: "appContent/bulkImport",
      type: BulkImportTypes.SPORTROOMCONTENTS,
      title: "Import elements",
      showNumberElems: false,
      sessionParams: ['appId', 'areaId'],
      formConfig: [
        {
          attributeName: 'type',
          helpText: 'Type of import',
          type: FormInputTypes.TEXT_INPUT.TEXT,
          required: true,
          label: 'Type',
          defaultValue: BulkImportTypes.SPORTROOMCONTENTS,
          hidden: true
        },
        {
          attributeName: 'composeExperienceCreation',
          helpText: 'Always generate compose experience',
          type: FormInputTypes.CHECKBOX,
          required: true,
          label: 'Duplicate Composed experiences if exist',
        },
        {
          attributeName: 'composeExperienceCreationText',
          helpText: 'Generate compose experience',
          type: FormInputTypes.TEXT,
          disabled: true,
          required: true,
          default: "ATTENTION! If checked, we will create different composed experiences for the new pasted contents.",
          label: 'Compose experience creation',
        },
      ]
    },
    {
      label: "Delete",
      color: ButtonTheme.ERROR,

      action: "bulkDelete",
      title: "Select records to delete",
      showNumberElems: true,
      disabled: 'no-selection',
      hidden: 'no-selection'
    },
    // {label:"Clone",
    //   color:ButtonTheme.DARK,
    //   action:"bulkClone",
    //   title:"Clone records",
    //   showNumberElems:true,
    //   disabled:'no-selection',
    //   hidden:'no-selection'
    // },
    {
      label: "Export",
      color: ButtonTheme.INFO,
      action: "bulkExport",
      title: "Export records",
      type: BulkImportTypes.SPORTROOMCONTENTS,
      showNumberElems: true,
      disabled: 'no-selection',
      hidden: 'no-selection'
    },
    {
      label: "Edit",
      color: ButtonTheme.INFO,
      action: "bulkEdit",
      actionUrl: "appContent/bulkEdit",
      type: BulkImportTypes.SPORTROOMCONTENTS,
      title: "Edit elements",
      showNumberElems: true,
      disabled: 'no-selection',
      hidden: 'no-selection',
      sessionParams: ['appId', 'areaId'],
      formConfig: [
        {
          attributeName: 'type',
          helpText: 'Type of import',
          type: FormInputTypes.TEXT_INPUT.TEXT,
          required: true,
          label: 'Type',
          defaultValue: BulkImportTypes.SPORTROOMCONTENTS,
          hidden: true
        },
        {
          attributeName: 'visibilityActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace by this selection', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'visibility',
          label: 'Visibility',
          helpText: 'Visibility of the video in the panel its listed.',
          default: '',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No selection)', value: '' },
            { name: 'Enabled', value: 'enabled' },
            { name: 'Hidden', value: 'hidden' },
          ],
          className: 'd-inline-block col-sm-8',
          enabledWhen: { "field": "visibilityActions", "notValues": ['(Empty)'] },

        },
        {
          attributeName: "sep1",
          type: FormInputTypes.SEPARATOR
        },
        {
          attributeName: 'appCategoriesActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
            { name: 'Add to existing', value: 'add' },
            { name: 'Find and remove these', value: 'remove' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'appCategories',
          label: 'Categories',
          type: FormInputTypes.RELATIONSHIP,
          canEdit: true,
          canCreate: true,
          canFilter: true,
          configFile: viewAppCategories,
          default: [],
          helpText: 'Video categories joined.',
          className: 'd-inline-block col-sm-8',
          enabledWhen: { "field": "appCategoriesActions", "notValues": ['(Empty)'] },

        },
        {
          attributeName: 'appPackagesActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'appPackages',
          label: 'V.T. Providers',
          type: FormInputTypes.RELATIONSHIP,
          canEdit: true,
          canCreate: true,
          maxElements: 1,
          configFile: viewRelatedAppPackages,
          default: [],
          helpText: 'This content can be blocked by a virtual ticket provider, select one or multiple providers to block it.',
          enabledWhen: { "field": "appPackagesActions", "notValues": ['(Empty)'] },
          className: 'd-inline-block col-sm-8',
        },
        {
          attributeName: "sep2",
          type: FormInputTypes.SEPARATOR
        },
        {
          attributeName: 'activationEpochActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'activationEpoch',
          label: 'Activation Time',
          helpText: 'Date of the activation event for this video.',
          type: FormInputTypes.DATE_TIME,
          default: '',
          sendAlwaysAtCreate: true,
          className: 'd-inline-block col-sm-8',
          enabledWhen: { "field": "activationEpochActions", "notValues": ['(Empty)'] },


        },
        {
          attributeName: 'expirationEpochActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'expirationEpoch',
          label: 'Expiration Time',
          helpText: 'Date of the expiration event for this video.',
          type: FormInputTypes.DATE_TIME,
          default: '',
          sendAlwaysAtCreate: true,
          className: 'd-inline-block col-sm-8',
          enabledWhen: { "field": "expirationEpochActions", "notValues": ['(Empty)'] },

        },
        {
          attributeName: 'isLiveContinuousActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'isLiveContinuous',
          label: 'Remove Progress Indicator',
          helpText: 'Selecting this field hides the current progress indicator from the player bar, making it invisible to the end user. This option should remain checked for 24/7 live streams.',
          default: '',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No selection)', value: '(Empty)' },
            { name: 'No', value: 'no' },
            { name: 'Yes', value: 'yes' },
          ],
          className: 'd-inline-block col-sm-8',
          enabledWhen: { "field": "isLiveContinuousActions", "notValues": ['(Empty)'] },


        },
        {
          attributeName: "sep3",
          type: FormInputTypes.SEPARATOR
        },
        {
          attributeName: 'isSlowMotionAllowedActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'isSlowMotionAllowed',
          helpText: 'Specifies if the content allow slow motion.',
          label: 'Allow Slow motion ',
          type: FormInputTypes.SELECT,
          default: '',
          options: [
            { name: '(No selection)', value: '(Empty)' },
            { name: 'No', value: 'no' },
            { name: 'Yes', value: 'yes' },
          ],
          className: 'd-inline-block col-sm-8',
        },
        {
          attributeName: 'isTimeShiftingAllowedActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'isTimeShiftingAllowed',
          helpText: 'Specifies if the content allow slow motion.',
          label: 'Allow Timeshift ',
          default: '',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No selection)', value: '(Empty)' },
            { name: 'No', value: 'no' },
            { name: 'Yes', value: 'yes' },
          ],
          className: 'd-inline-block col-sm-8',

        },
        {
          attributeName: 'allow_screen_recordingActions',
          label: 'Action',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'allow_screen_recording',
          helpText: 'Specifies if the content is allowed to be record.',
          label: 'Allow Screen Recording ',
          type: FormInputTypes.SELECT,
          default: '',
          options: [
            { name: '(No selection)', value: '(Empty)' },
            { name: 'No', value: 'no' },
            { name: 'Yes', value: 'yes' },
          ],
          className: 'd-inline-block col-sm-8',
        },
        {
          attributeName: 'allow_castingActions',
          label: 'Action',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'allow_casting',
          helpText: 'Specifies if the content is allowed to be cast.',
          label: 'Allow Casting ',
          type: FormInputTypes.SELECT,
          default: '',
          options: [
            { name: '(No selection)', value: '(Empty)' },
            { name: 'No', value: 'no' },
            { name: 'Yes', value: 'yes' },
          ],
          className: 'd-inline-block col-sm-8',
        },
        {
          attributeName: "sep4",
          type: FormInputTypes.SEPARATOR
        },
        {
          attributeName: 'backgroundFlatActions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'backgroundFlat',
          type: FormInputTypes.BACKGROUND,
          label: 'Background Flat',
          helpText: 'Background to use in the flat video geometries.',
          fileType: ['.jpg', '.jpeg', '.png'],
          className: 'd-inline-block col-sm-8',
          enabledWhen: { "field": "backgroundFlatActions", "notValues": ['(Empty)'] },

        },
        {
          attributeName: 'background180Actions',
          label: 'Action',
          // helpText: 'How do you want to make the update?',
          default: '(Empty)',
          type: FormInputTypes.SELECT,
          options: [
            { name: '(No action)', value: '(Empty)' },
            { name: 'Replace all with', value: 'replace' },
          ],
          className: 'd-inline-block col-sm-4',
        },
        {
          attributeName: 'background180',
          type: FormInputTypes.BACKGROUND,
          label: 'Background 180',
          helpText: 'Background to use in the 180 video geometries.',
          fileType: ['.jpg', '.jpeg', '.png'],
          className: 'd-inline-block col-sm-8',
          enabledWhen: { "field": "background180Actions", "notValues": ['(Empty)'] },

        },
      ]
    },
  ],
  createPath: routes.APP_CONTENT_NEW,
  editURL: routes.APP_CONTENT_EDIT,
  fromCatalogTable: tableSportRoomContentCatalog,
  fromCatalogTableMultiple: true,
  emptyMessage: "You don't have videos, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'visibility',
      label: 'Visibility',
      type: FormInputTypes.SELECT,
      helpText: 'Visibility of the video in the panel where its listed.',
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
      canEdit: true,
      canCreate: false,
      exactWidth: '80px',
    },
    {
      attributeName: 'isLive',
      label: 'T',
      type: FormInputTypes.TAG,
      colorWhen: [{ value: true, color: "#ffffff" }, { value: false, color: "#ffffff" }],
      bkWhen: [{ value: true, color: "#f12027" }, { value: false, color: "#0133FB" }],
      textWhen: [{ value: true, text: "LIVE" }, { value: false, text: "VOD" }],
      maxTagWidth: '40px',
      helpText: 'type of content (Live or VOD).',
      exactWidth: '30px',
      small: true
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Title of the video.',
      default: '',
      canEdit: true,
      canCreate: false,
      canFilter: true,
      width: '45rem'
    },
    {
      attributeName: 'appCategories',
      label: 'Categories',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      configFile: viewAppCategories,
      default: [],
      helpText: 'Video categories joined.',
      exactWidth: '200px',
      additionalCss: "hide-on-S"
    },
    {
      attributeName: 'appPackages',
      label: 'V.T. Providers',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      configFile: viewRelatedSportRoomPackages,
      default: [],
      helpText: 'Video categories joined.',
      exactWidth: '150px',
      additionalCss: "hide-on-M"

    },
    {
      attributeName: 'appTags',
      label: 'Tags',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      configFile: viewRelatedSportRoomTags,
      default: [],
      helpText: 'Video categories joined.',
      width: '30rem',

    },
    {
      attributeName: 'sortingIndex',
      label: 'Pos',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      default: [],
      exactWidth: '30px',
      small: true

    },
  ],
};
